// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_1gRk4","visuallyhidden":"_12gYb","hide-text":"hNXFb","center":"_6U9ju","noprint":"_3Ff62","root":"_3Lfly","buttonlist":"_3nN_1","listItem":"_3MM_N","button":"_39ttG","linkCopiedMessage":"_11Krg"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-share/styles/Share.scss
 ** module id = 950
 ** module chunks = 1
 **/